module.exports = __webpack_public_path__ + "static/media/f3c2877d-bd7d-4b76-9942-1dbd4f512df9.a881e4d4.JPG";